import trans from './getText';

let i18n = trans;

const getMessages = () => {
  return {
    Layers: i18n.gettext('Layers'),
    Search: i18n.gettext('Search'),
    Settings: i18n.gettext('Settings'),
    'Rendering quality': i18n.gettext('Rendering quality'),
    'Zoom to': i18n.gettext('Zoom to'),
    Share: i18n.gettext('Share'),
    'Map link': i18n.gettext('Map link'),
  };
};

export default new Promise((resolve) => {
  try {
    i18n = (window.require as any)(
      ['@nextgisweb/pyramid/i18n!custom_webmap'],
      (resp: any) => {
        i18n = resp;
        resolve(getMessages());
      },
    );
  } catch (er) {
    resolve(getMessages());
  }
});
